import React from 'react'
import { TrolleyIcon } from '@sainsburys-tech/bolt-icons'
import { isEmpty } from '@sainsburys-tech/boltui-utils'
import { Alert } from '@sainsburys-tech/bolt'
import * as Styled from './ugc.styles'
import { alertMessage } from './ugc.helpers'

const GenerateCTABlock = () => {
  return (
    <Styled.CTAblock>
      <TrolleyIcon key='icon' height='25px' width='25px' />
      <Styled.PrimaryText>Tap Photos</Styled.PrimaryText>
      <div>To view and shop items</div>
    </Styled.CTAblock>
  )
}

const CreateAlert = (status, images, channel) => {
  const { isLoading } = status
  const type = !isLoading && isEmpty(images) ? 'empty' : 'error'
  return (
    <Alert kind='error' isCloseable={false}>
      {alertMessage(type, channel)}
    </Alert>
  )
}

export { GenerateCTABlock, CreateAlert }
